import React, { CSSProperties, useCallback } from "react"


export interface Option {
  label: string
  value: string
}

export interface RadioButtonGroupProps {
  name: string
  title: string
  options: Option[]
  value?: string | null
  required?: boolean
  style?: CSSProperties
  onChange: (value: string) => void
}
export function RadioButtonGroup({
  name,
  title,
  options,
  onChange: onChangeProp,
  value: valueProp,
  required: requiredProp,
  style,
}: RadioButtonGroupProps): React.ReactNode {

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeProp(event.currentTarget.value)
  }, [onChangeProp])

  const required = requiredProp ?? false
  const dataShow = `.show-${name}`
  const value = valueProp || ""
  const labelId = `radiogroup_${name}_label`

  return (
    <div className="form-group" role="radiogroup" aria-labelledby={labelId} style={style}>
      <label className="col-sm-12 required" id={labelId} style={{marginBottom: "12px"}}>{title}</label>
      <div className="col-sm-11 col-sm-offset-1">
        {options.map((option) => {
          return (
            <div className="radio" key={option.value}>
              <label>
                <input
                  type="radio"
                  onChange={onChange}
                  name={name}
                  value={option.value}
                  defaultChecked={value === option.value}
                  data-show={dataShow}
                  data-fv-notempty={required}
                  required={required}
                  data-fv-ignore-error-message={true}
                  data-fv-notempty-message=""
                />
                {option.label}
              </label>
            </div>
          )
        })}
      </div>
    </div>
  )
}
